import { safeSessionStorage } from '@/utils/helpers';
import { WEB_STORAGE_PREFIX } from './constants';

const INITIAL_REFERRER_STORAGE_NAME = `${WEB_STORAGE_PREFIX}initialReferrer`;

/**
 * Persists the page's referrer in sessionStorage on the first call only.
 * sessionStorage survives same-tab cross-origin redirects (e.g. Auth0 login and back),
 * so the referrer captured on first arrival is preserved even after authentication.
 * Using sessionStorage (not localStorage) means each new session gets a fresh referrer
 * rather than keeping a stale value from a previous visit.
 */
export function storeInitialReferrer(): void {
  if (safeSessionStorage.get(INITIAL_REFERRER_STORAGE_NAME) !== null) {
    return;
  }
  safeSessionStorage.set(INITIAL_REFERRER_STORAGE_NAME, document.referrer);
}

/**
 * Returns the referrer captured on the user's first visit, or undefined if absent.
 */
export function retrieveInitialReferrer(): string | undefined {
  return safeSessionStorage.get(INITIAL_REFERRER_STORAGE_NAME) ?? undefined;
}
